import { UseCase } from '../UseCase';

export class StorageGet<T> implements UseCase<string, T | undefined> {
    execute(key: string): T | undefined {
        const value = localStorage.getItem(`mdd.${key}`);
        return value && JSON.parse(value);
    }
}
